var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"unpakt-widget",attrs:{"src":"https://www.unpakt.com/affiliates-widget/"}})}
var staticRenderFns = []

export { render, staticRenderFns }